import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TimelineLite} from "gsap";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborHelper} from "../../utils/PearlHarborHelper";
import {IFinalWave} from "../../server/PearlHarborData";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {PearlHarborModel} from "../../server/PearlHarborModel";


export class PearlHarborCocpitColumnWinRunner implements FlowStatePresentation {
    private _tl: TimelineLite

    public shouldRun(): boolean {
        const isFs: boolean = PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.mode);
        if (!isFs) {
            return false;
        }
        const model: PearlHarborModel = PearlHarbor.model;
        let hasColumnWin: boolean = model.dogfight?.filledColumns!.indexOf(true) > -1,
            hasRowWin: boolean = false;

        if (!(model.data.mode === GameMode.FREESPIN || model.data.nextMode === GameMode.FREESPIN)) {
            hasRowWin = (<IFinalWave>model.dogfight).filledRowThisSpin!.indexOf(true) > -1;
        }

        if (model.gameData.brokeBank && model.dogfight.integerRepresentingWhenBreakBank < 1) {
            return false;
        }

        return (hasColumnWin || hasRowWin);
    }

    private completePresentation(flowStateController: FlowStateController) {
        flowStateController.finish();
    }

    public start(flowStateController: FlowStateController): void {
        this._tl = new TimelineLite();
        let hasMGUpdate:boolean = false;
        let hasBAUpdate:boolean = false;

        const model: PearlHarborModel = PearlHarbor.model;
        model.dogfight?.filledColumnThisSpin!.forEach((hasWon: boolean, s: number) => {
            if (hasWon) {
                hasMGUpdate = true;
                this._tl.add(PearlHarbor.cocpitBoard.fillColumnWin(s));
                this._tl.add(PearlHarbor.dogfightWin.show(s));
            }
        });
        this._tl.add(PearlHarbor.cocpitBoard.updateMGProgress());
        if (!(model.gameData.brokeBank && model.dogfight.integerRepresentingWhenBreakBank < 11)) {
            if (!(model.data.mode === GameMode.FREESPIN || model.data.nextMode === GameMode.FREESPIN)) {
                (<IFinalWave>model.dogfight).filledRowThisSpin!.forEach((filledRow: boolean, i: number) => {
                    if (filledRow) {
                        hasBAUpdate = true;
                        this._tl.add(PearlHarbor.cocpitBoard.fillRowWin(i));
                        this._tl.add(PearlHarbor.bombAttackWin.show(i));
                    }
                });
                this._tl.add(PearlHarbor.cocpitBoard.updateBAProgress());
            }
        }
        this._tl.add(() => {}, 0.1);
        this._tl.add(() => this.completePresentation(flowStateController));
    }


}